import { useMemo } from 'react'
import { useFiltersApi, useFiltersStore } from '@/hooks'
import { mapBillingFiltersGetParams } from '@/features/BillingPayments/stores/useBillingFiltersStore/mapBillingFiltersGetParams'
import { ReportFiltersValues } from '@/features/Analytics/stores/useAnalyticsFiltersStore/types'

export const useBillingFiltersGetParams = (
    activeBillingFilters: ReportFiltersValues
) => {
    const rootNode = useFiltersStore((state) => state.rootNode)

    const { useCommoditiesQuery } = useFiltersApi()
    const { data: commodities } = useCommoditiesQuery({
        'nodeIds[]': rootNode?.nodeId.toString(),
    })

    const billingFiltersParams = useMemo(() => {
        const passedFilters = Object.assign({}, activeBillingFilters)

        if (!passedFilters.node.length && rootNode) {
            passedFilters.node = [rootNode.nodeId]
        }

        if (!passedFilters.commodity.length && commodities) {
            passedFilters.commodity = commodities.map(
                (commodity) => commodity.commodityTypeId
            )
        }

        return mapBillingFiltersGetParams({
            filters: passedFilters,
        })
    }, [activeBillingFilters, commodities, rootNode])

    return billingFiltersParams
}
